import React, {Component} from "react";
import "./PageAuth.css";
import {clearToken, setToken} from "../utils/authToken";
import config from "../config";

export class PageAuth extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
            loading: false,
            error: null
        };
    }

    onChangeUsername = (e) => {
        this.setState({username: e.target.value});
    };

    onChangePassword = (e) => {
        this.setState({password: e.target.value});
    };

    onClickSignIn = () => {
        this.setState(
            {loading: true},
            () => {
                fetch(config.backendUrl + '/auth/signin', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        username: this.state.username,
                        password: this.state.password
                    })
                })
                    .catch(() => {
                        throw new Error("Network issue");
                    })
                    .then(result => {
                        switch (result.status) {
                            case 401:
                                throw new Error("Invalid username / password");
                            default:
                                return result;
                        }
                    })
                    .then(res => res.json())
                    .then(token => {
                        setToken(`${token.tokenType} ${token.accessToken}`);
                        this.setState({loading: false, error: null});
                        window.location.reload();
                    })
                    .catch(error => {
                        clearToken();
                        this.setState({loading: false, error: error.message});
                    });
            }
        );
    };

    render() {
        return [<div className="block-header">
            <div className="block-title">Mind Web</div>
        </div>,
            <div className="block-content">
                <div className="form">
                    <input type="text" placeholder="User name" value={this.state.username} onChange={this.onChangeUsername}/>
                    <input type="password" placeholder="Password" value={this.state.password} onChange={this.onChangePassword}/>
                    <button onClick={this.onClickSignIn} disabled={this.state.loading}>Sign in</button>
                    {this.state.error && <div className="error mt-3">{this.state.error}</div>}
                </div>
            </div>];
    }
}
